/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Sidebar_Usage_AriaInputs */



/**
* | output |
* | --- |
* | "Daily AI allowance: {pct}% used" |
*
* @param {Sidebar_Usage_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_usage_aria = /** @type {((inputs: Sidebar_Usage_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Usage_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tägliches KI-Guthaben: ${i?.pct}% verbraucht`)
	return /** @type {LocalizedString} */ (`Daily AI allowance: ${i?.pct}% used`)
});